import AuthLayout from "@/Frontend/Layouts/AuthLayout"
import { Head, Link, useForm } from "@inertiajs/react"
import translate from "@/utils/translate"
import BioneMeta from "@/utils/BioneMeta"
import { useState } from "react"
import ReCAPTCHA from "react-google-recaptcha"

export default function Register({ terms_condition_url, is_facebook_login_active, is_google_login_active, meta_tags, tagline, site_name }) {
    const captchaSiteKey = localStorage.getItem("google_captcha_site_key") ? JSON.parse(localStorage.getItem("google_captcha_site_key")) : []
    const is_active_google_captcha = localStorage.getItem("is_active_google_captcha")
        ? JSON.parse(localStorage.getItem("is_active_google_captcha"))
        : []
    const [captchaVerified, setCaptchaVerified] = useState(false)
    const [captchaError, setCaptchaError] = useState(null)

    const { data, setData, errors, post, processing } = useForm({
        name: "",
        email: "",
        about: "",
        password: "",
        password_confirmation: "",
        agreed: false
    })

    BioneMeta(tagline, "", meta_tags, "", "", site_name)

    const handleCaptchaChange = (value) => {
        if (is_active_google_captcha === "1") {
            if (value) {
                setData("captchaToken", value)
                setCaptchaVerified(true)
                setCaptchaError(null)
            } else {
                setCaptchaVerified(false)
            }
        }
    }

    // handle register
    const handleSignUp = (e) => {
        e.preventDefault()

        if (!captchaVerified && is_active_google_captcha === "1") {
            setCaptchaError(translate("Please complete the captcha verification"))
            return
        }

        post(route("register"))
    }

    // Toggle password visibility
    const togglePasswordVisibility = (id) => {
        const input = document.getElementById(id);
        if (input) {
            input.type = input.type === 'password' ? 'text' : 'password';
        }
    }

    return (
        <AuthLayout>
			<Head title="Register" />
			
			<header>
				<h2 className="cs_login_title">{translate("Create your account")}</h2>
				<p className="cs_login_subtitle">
					{translate("Join us today and start managing your operations efficiently.")}
				</p>
			</header>

			<form onSubmit={handleSignUp} className="">
				{/* Name Field */}
				<div className="cs_mb_15">
					{/*<label htmlFor="name">{translate("Name")}*</label>*/}
					<div className="cs_input_shell">
						<span className="cs_input_addon">
							<i className="fa-regular fa-user"></i>
						</span>
						<input 
							id="name" 
							type="text" 
							className="cs_form_field" 
							placeholder={translate("Name")}
							onChange={(e) => setData("name", e.target.value)} 
							value={data?.name} 
						/>
					</div>
					<span style={{ color: "red" }}>{errors.name}</span>
				</div>

				{/* Email Field */}
				<div className="cs_mb_15">
					{/*<label htmlFor="email">{translate("Email")}*</label>*/}
					<div className="cs_input_shell">
						<span className="cs_input_addon">
							<i className="fa-regular fa-envelope"></i>
						</span>
						<input
							id="email"
							type="email"
							className="cs_form_field"
							placeholder={translate("Email")}
							onChange={(e) => setData("email", e.target.value)}
							value={data?.email}
						/>
					</div>
					<span style={{ color: "red" }}>{errors.email}</span>
				</div>



				{/* About Field */}
				<div className="cs_mb_15">
					<div className="cs_input_shell">
						<span className="cs_input_addon">
							<i className="fa-regular fa-phone"></i>
						</span>
						<input
							id="about"
							type="tel"
							className="cs_form_field"
							placeholder={translate("012 345 678 90")} 
							onChange={(e) => setData("about", e.target.value)}
							value={data?.about}
						/>
					</div>
					<span style={{ color: "red" }}>{errors.about}</span>
				</div>

				{/* Password Field */}
				<div className="cs_mb_15">
					{/*<label htmlFor="password">{translate("Password")}*</label>*/}
					<div className="cs_input_shell">
						<span className="cs_input_addon">
							<i className="fa-regular fa-lock"></i>
						</span>
						<input 
							id="password" 
							type="password" 
							className="cs_form_field" 
							placeholder={translate("Password")}
							onChange={(e) => setData("password", e.target.value)} 
						/>
						<button 
							type="button" 
							className="cs_toggle_password" 
							onClick={() => togglePasswordVisibility('password')}
						>
							<i className="fa-regular fa-eye m-1"></i>
							<span className="cs_toggle_text">{translate("Show")}</span>
						</button>
					</div>
					<span style={{ color: "red" }}>{errors.password}</span>
				</div>

				{/* Confirm Password Field */}
				<div className="cs_mb_15">
					{/*<label htmlFor="password_confirmation">{translate("Confirm Password")}*</label>*/}
					<div className="cs_input_shell">
						<span className="cs_input_addon">
							<i className="fa-regular fa-lock"></i>
						</span>
						<input
							id="password_confirmation"
							type="password"
							className="cs_form_field"
							placeholder={translate("Confirm Password")}
							onChange={(e) => setData("password_confirmation", e.target.value)}
						/>
						<button 
							type="button" 
							className="cs_toggle_password" 
							onClick={() => togglePasswordVisibility('password_confirmation')}
						>
							<i className="fa-regular fa-eye m-1"></i>
							<span className="cs_toggle_text">{translate("Show")}</span>
						</button>
					</div>
					<span style={{ color: "red" }}>{errors.password_confirmation}</span>
				</div>

				{/* CAPTCHA */}
				{is_active_google_captcha === "1" && (
					<div className="cs_mb_15">
						<ReCAPTCHA sitekey={captchaSiteKey} onChange={handleCaptchaChange} />
						{captchaError && <div className="text-danger mb-3">{captchaError}</div>}
					</div>
				)}

				{/* Terms and Conditions */}
				<div className="cs_mb_15">
					<div className="cs_custom_checkbox">
						<input
							className="cs_custom_checkbox_input"
							type="checkbox"
							id="gridCheck"
							checked={data.agreed}
							onChange={(e) => setData("agreed", e.target.checked)}
						/>
						<label htmlFor="gridCheck" className="cs_custom_checkbox_label">
							<Link href={terms_condition_url}>{translate("Accept Terms And Conditions")}</Link>
						</label>
					</div>
					<br />
					{errors.agreed && <span style={{ color: "red" }}>{errors.agreed}</span>}
				</div>

				{/* Register Button */}
				<div className="cs_mb_20">
					<button
						type="submit"
						disabled={!captchaVerified && processing}
						className="cs_btn cs_style_1 cs_type_2 cs_primary_bg cs_white_color cs_w_100_sm w-100"
					>
						{translate("Register")}
						<span>
							<i>
								<svg width={11} height={11} viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path
										d="M1 10L10 1M10 1L1 1M10 1L10 10"
										stroke="currentColor"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							</i>
							<i>
								<svg width={11} height={11} viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path
										d="M1 10L10 1M10 1L1 1M10 1L10 10"
										stroke="currentColor"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							</i>
						</span>
					</button>
				</div>
				<p className="cs_mb_20 cs_or_login">
					{(is_facebook_login_active ?? is_google_login_active) && <span>{translate("Or login with")}</span>}
				</p>
				<div className="cs_social_btns cs_mb_20">
					{is_facebook_login_active && (
						<a href={route("social.redirect", "facebook")} className="cs_social_btn cs_social_btn_facebook">
							<Icon style={{ fontSize: "22px" }} icon="logos:facebook" />
							{translate("Login With Facebook")}
						</a>
					)}
					{is_google_login_active && (
						<a href={route("social.redirect", "google")} className="cs_social_btn cs_social_btn_google">
							<Icon style={{ fontSize: "22px" }} icon="logos:google-icon" />
							{translate("Login With Google")}
						</a>
					)}
				</div>
				<p className="mb-0 cs_primary_color">
					{translate("Already have an account")}{" "}
					<Link href={route("login.create")} className="cs_card_text_btn">
						{translate("Sign In Now")}
					</Link>
				</p>
			</form>
        </AuthLayout>
    )
}